import { createUseStyles } from 'react-jss'
import { black, darkGrey, mediumGrey, lightGrey } from '../../styles/const/colors'
import { defaultBorderRadius } from '../../styles/const/common'
import { smallPhonesDown } from '../../styles/const/breakpoints'

export default createUseStyles(theme => ({
  toastNotify: {
    width: '100%'
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 13
  },
  titleText: {
    fontSize: 12,
    lineHeight: '14px',
    color: mediumGrey,
    textTransform: 'uppercase'
  },
  icon: {
    marginRight: 8
  },
  closeBtn: {
    marginLeft: 'auto',
    marginTop: -7
  },
  message: {
    color: darkGrey,
    fontSize: 14,
    overflowWrap: 'anywhere'
  },
  '@global': {
    '.Toastify__toast': {
      background: 'white !important',
      color: black,
      padding: '10px 10px 20px',
      borerRadius: defaultBorderRadius,
      border: {
        width: 1,
        style: 'solid',
        color: lightGrey
      },

      '&-container': {
        '.Toastify &': {
          width: '100%',
          maxWidth: 320,
          top: 60,
          right: 10
        }
      },

      '&-body': {
        margin: 0,
        padding: '10px 10px 20px',
        width: '100%'
      }
    },

    '.Toastify__progress-bar': {
      backgroundColor: [theme.brandPrimary, '!important']
    },
    [`@media screen and (${smallPhonesDown})`]: {
      '.Toastify__toast-container': {
        left: '50% !important',
        transform: 'translateX(-50%) !important'
      }
    }
  }
}))
